import { IKnmErknmFormApproveRemark } from '../../MainModule/interfaces/IKnmErknmFormApproveRemark';

export const approveRemarkToString = (value: IKnmErknmFormApproveRemark): string => {
  if (!value.remark) {
    return '';
  }

  if (value.description) {
    return `${value.remark.name} (${value.description})`;
  }

  return value.remark.name;
};
